import {
  dataType,
  tsStudyAttribute,
} from '../../../Typescript/StuartPy/StudyAttribute'
import { Badge, Chip, Tooltip } from '@mui/material'
import { PriorityHigh } from '@mui/icons-material'
import { DBtoUI, OBJtoDB, OBJtoUI } from '../FormulaBuilder/FormulaFunctions'
import { useMemo } from 'react'
import { useStudyContext } from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import { useStudyAttr } from '../StudyFns'
import { tsStudyPhase } from '../../../Typescript/StuartPy/StudyPhase'
import { GridColDef } from '@mui/x-data-grid-pro'

export function useAttributeColsDF(phase: tsStudyPhase): GridColDef[] {
  const { studyQuery } = useStudyContext()
  const histAttr = useStudyAttr()

  const idToName = useMemo(() => {
    const idMap: any = {}
    studyQuery.data?.phases?.forEach((p) => (idMap[p.PhaseID] = p.PhaseName))
    return idMap
  }, [studyQuery.data?.phases])

  const dbToUImap = useMemo(() => {
    const dbToUImap: any = {}
    phase.attributes.forEach((obj) => {
      dbToUImap[OBJtoDB(obj, 'new')] = OBJtoUI(obj, idToName, 'new')
    })
    histAttr.forEach((obj) => {
      dbToUImap[OBJtoDB(obj, 'hist')] = OBJtoUI(obj, idToName, 'hist')
    })
    return dbToUImap
  }, [phase.attributes, histAttr, idToName])

  return [
    {
      type: 'number',
      field: 'AttrID',
      headerName: 'ID',
      sortable: false,
    },
    {
      type: 'string',
      field: 'AttrName',
      headerName: 'Name',
      sortable: false,
      width: 200,
    },
    {
      type: 'number',
      field: 'SeqNo',
      headerName: 'Sequence',
    },
    {
      type: 'singleSelect',
      field: 'AttrDatatype',
      headerName: 'Type',
      sortable: false,
      width: 80,
      renderCell: ({ value, row }: { row: tsStudyAttribute; value?: any }) => {
        let error = ''
        if (!row?.Formula) {
          if (row?.AttrDatatype === dataType.Endpoint) {
            error = "An 'Endpoint' Attribute must have a Formula defined"
          } else if (row?.AttrDatatype === dataType['Calculated Field']) {
            error = "A 'Calculation' Attribute must have a Formula defined"
          }
        }
        return (
          <Tooltip title={error}>
            <Badge
              color="error"
              badgeContent={<PriorityHigh sx={{ fontSize: '0.8rem', px: 0 }} />}
              invisible={!error}
            >
              <Chip label={value} />
            </Badge>
          </Tooltip>
        )
      },
    },
    {
      field: 'AttrCodeSetID',
      headerName: 'CodeSetID',
      sortable: false,
    },
    {
      field: 'options',
      headerName: 'options',
    },
    {
      field: 'CodeSetCount',
      headerName: 'Options',
      sortable: false,
      width: 80,
    },
    {
      field: 'EndpointText',
      headerName: 'Endpoint',
      flex: 2,
      sortable: false,
    },
    {
      field: 'Formula',
      headerName: 'Formula',
      flex: 3,
      sortable: false,
      valueFormatter: (value: any) => {
        try {
          return value ? DBtoUI(value, dbToUImap) : value
        } catch (e) {
          console.error(e)
          return value
        }
      },
    },
  ]
}
